import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom/client";
import { DataGrid } from 'devextreme-react';
import { Box } from '@mui/material';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { IPricelistMedia } from 'interfaces/ElementModels/IPricelistMedia';
import { IPricelistMasterDetailProps } from 'interfaces/Pricelist/IPricelistMasterDetailProps';
import TrackingAnalysisCell from './components/TrackingAnalysisCell';
import './MediaInfo.scss';

const MediaInfo = (props: IPricelistMasterDetailProps) => {
  const { getMediaInfo } = PricelistApis();
  const [error, setError] = useState('');
  const [mediaInfo, setMediaInfo] = useState<IPricelistMedia[] | undefined>();
  const [loadingMediaInfo, setLoadingMediaInfo] = useState<boolean>(true);

  useEffect(() => {
    getMediaInfo(props.analysis, props.matrix)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setMediaInfo(data);
        }
      })
      .catch((e) => setError(e))
      .finally(() => setLoadingMediaInfo(false));
  }, [props, getMediaInfo]);

  return(
    <Box className="mediaInfo">
      {error && !(mediaInfo?.length > 0) ? <Box className="errorBox">{error}</Box> : null}
      {!error && loadingMediaInfo ? <Box className="loadingBox">Loading Media Info...</Box> : null}
      
      {!loadingMediaInfo && mediaInfo?.length > 0 ?
      <DataGrid
        dataSource={mediaInfo}
        rowAlternationEnabled={true}
        showBorders={false}
        wordWrapEnabled={true}
        hoverStateEnabled={false}
        paging={{ enabled: false }}
        headerFilter={{ visible: false }}
        columns={[
          { dataField: "Media", dataType: "string" },
          {
            dataField: "TrackingAnalysis",
            caption: "Media Supply Details",
            dataType: "string",
            cellTemplate: (container, options) => {
              const root = ReactDOM.createRoot(container);
              root.render(<TrackingAnalysisCell trackingAnalysis={options?.data?.TrackingAnalysis} />);
            },
          },
        ]}
      /> : null }
    </Box>
  );
};

export default React.memo(MediaInfo);
